import React, { Component } from 'react';
import MenuAppBar from './MenuAppBar.jsx'
import Box from '@mui/material/Box';
import Container from '@mui/material/Container'
import { Toolbar } from '@mui/material';
import Copyrigth from './Copyrigth.jsx';
import AppBreadcrumbs from './AppBreadcrum';

export class Layout extends Component {
  static displayName = Layout.name;

  render () {

    return (
      <>
        <MenuAppBar onOpenFaqs={this.props.onOpenFaqs}>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
          <AppBreadcrumbs/>
                    <Container maxWidth="lg" sx={{ mt: 1, mb: 1 }}>

        {this.props.children}
        </Container>
        {/* <Copyrigth  sx={{ pt: 2, bottom:2 }}/> */}
         </Box>
          </MenuAppBar>
          
         
      </>
    );
  }
}
